'use client'

import { log } from '@dustin-web/microsite-config/src/logger'

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  // eslint-disable-next-line no-console
  console.error({ error })

  log.warn({ err: error }, '[APP]: Global Server Error')

  return (
    <html>
      <head></head>
      <body>
        <div className="s-microsite">
          <h2>Something went wrong in RootLayout!</h2>
          <button onClick={() => reset()}>Try again</button>
        </div>
      </body>
    </html>
  )
}
